import { mapGetters } from 'vuex';
import { InventoryFormFormGetters } from '../../store/getters';
import { InventoryFormAction } from '../../enums/inventoryFormAction';
import { InventoryFormOperator } from '../../enums/inventoryFormOperator';
import gridViewFieldsUtils from '../../utils/gridViewFieldsUtils';
export default {
	computed: {
		...mapGetters({
			interactions: [InventoryFormFormGetters.INTERACTIONS],
			selectedInventoryForm: [
				InventoryFormFormGetters.SELECTED_INVENTORY_FORM,
			],
		}),
		isVisible() {
			if (!this.formField) return false;
			if (
				this.formField.HiddenBehaviour > 0 &&
				this.formField.OnScanEdit === 0
			)
				return false;
			return this.visible;
		},
	},
	data() {
		return {
			visible: true,
			visibleBubble: false,
			bubbleText: '',
			visibleHelp: false,
			helpText: '',
			set: true,
			setValue: null,
			questionHelp: false,
		};
	},
	watch: {
		record() {
			this.udateFieldsBasedOnInteraction();
		},
		// visible(newVal) {
		//     if (newVal === false) {

		//         this.onHideFormField();
		//     }
		// }
	},
	mounted() {
		let interactions = this.getInteractionByActionValue(
			InventoryFormAction.Show
		);
		if (interactions.length > 0) this.visible = false;
	},
	methods: {
		udateFieldsBasedOnInteraction() {
			this.handleHideActions();
			this.handleShowActions();

			this.handleHideBubble();
			this.handleShowBubble();

			this.handleHideHelp();
			this.handleShowHelp();

			this.handleSet();
			this.handleQuestionHelp();
		},
		handleHideActions() {
			let interactions = this.getInteractionByActionValue(
				InventoryFormAction.Hide
			);
			interactions.forEach((i) => {
				if (this.validateConditions(i.Conditions)) {
					this.visible = false;
				} else {
					this.visible = true;
				}
			});
		},
		handleShowActions() {
			let interactions = this.getInteractionByActionValue(
				InventoryFormAction.Show
			);
			interactions.forEach((i) => {
				if (this.validateConditions(i.Conditions)) {
					this.visible = true;
				} else {
					this.visible = false;
				}
			});
		},
		handleHideBubble() {
			let interactions = this.getInteractionByActionValue(
				InventoryFormAction.HideBubble
			);
			interactions.forEach((i) => {
				if (this.validateConditions(i.Conditions)) {
					this.visibleBubble = false;
				} else {
					this.visibleBubble = true;
				}
			});
		},
		handleShowBubble() {
			let interactions = this.getInteractionByActionValue(
				InventoryFormAction.ShowBubble
			);
			this.bubbleText = '';
			interactions.forEach((i) => {
				var relatedActions = i.Actions.filter(
					(a) =>
						a.FormFieldId === this.formField.Id &&
						a.Value === InventoryFormAction.ShowBubble
				);
				if (relatedActions.length > 0)
					relatedActions.forEach((a) => {
						this.bubbleText += a.Comment + ' ';
					});
				if (this.validateConditions(i.Conditions)) {
					this.visibleBubble = true;
				} else {
					this.bubbleText = '';
					this.visibleBubble = false;
				}
			});
		},
		handleHideHelp() {
			let interactions = this.getInteractionByActionValue(
				InventoryFormAction.HideHelp
			);
			interactions.forEach((i) => {
				if (this.validateConditions(i.Conditions)) {
					this.visibleHelp = false;
				} else {
					this.visibleHelp = true;
				}
			});
		},
		handleShowHelp() {
			let interactions = this.getInteractionByActionValue(
				InventoryFormAction.ShowHelp
			);
			this.helpText = '';
			interactions.forEach((i) => {
				var relatedActions = i.Actions.filter(
					(a) =>
						a.FormFieldId === this.formField.Id &&
						a.Value === InventoryFormAction.ShowHelp
				);
				if (relatedActions.length > 0)
					relatedActions.forEach((a) => {
						this.helpText += a.Comment + ' ';
					});
				if (this.validateConditions(i.Conditions)) {
					this.visibleHelp = true;
				} else {
					this.helpText = '';
					this.visibleHelp = false;
				}
			});
		},
		handleSet() {
			let interactions = this.getInteractionByActionValue(
				InventoryFormAction.Set
			);
			this.setValue = null;
			interactions.forEach((i) => {
				var relatedActions = i.Actions.filter(
					(a) =>
						a.FormFieldId === this.formField.Id &&
						a.Value === InventoryFormAction.Set
				);
				if (relatedActions.length > 0)
					relatedActions.forEach((a) => {
						this.setValue = a.Comment;
					});
				if (this.validateConditions(i.Conditions)) {
					this.set = true;
				} else {
					this.setValue = null;
					this.set = false;
				}
			});
		},
		handleQuestionHelp() {
			let interactions = this.getInteractionByActionValue(
				InventoryFormAction.QuestionHelp
			);
			interactions.forEach((i) => {
				if (this.validateConditions(i.Conditions)) {
					this.questionHelp = true;
				} else {
					this.questionHelp = false;
				}
			});
		},

		getInteractionByActionValue(value) {
			let result = [];
			this.interactions.forEach((i) => {
				var relatedActions = i.Actions.filter(
					(a) =>
						a.FormFieldId === this.formField.Id && a.Value === value
				);
				if (relatedActions.length > 0) result.push(i);
			});
			return result;
		},

		validateConditions(conditions) {
			let result = true;
			conditions.forEach((c) => {
				let field = this.selectedInventoryForm.FormFields.find(
					(f) => f.Id == c.FormFieldId
				);
				if (field) {
					let key = gridViewFieldsUtils.getFieldName(
						field.GridViewFields[0]
					);
					switch (c.Operator) {
						case InventoryFormOperator.IsAnything:
							if (this.record[key]) result = result && true;
							else result = result && false;
							break;
						case InventoryFormOperator.IsBlank:
							if (
								this.record[key] === undefined ||
								this.record[key] === null ||
								this.record[key].trim() === ''
							)
								result = result && true;
							else result = result && false;
							break;
						case InventoryFormOperator.Is:
							if (c.Value == this.record[key])
								result = result && true;
							else result = result && false;
							break;
						case InventoryFormOperator.IsNot:
							if (c.Value != this.record[key])
								result = result && true;
							else result = result && false;
							break;
						case InventoryFormOperator.IsNotOneOf:
							if (!c.Value.includes(this.record[key]))
								result = result && true;
							else result = result && false;
							break;
						case InventoryFormOperator.IsOneOf:
							if (c.Value.includes(this.record[key]))
								result = result && true;
							else result = result && false;
							break;
					}
				}
			});
			return result;
		},
	},
};
